import React from "react";
import classNames from "classnames";
import { desktop } from "is_js";
import StickyBox from "react-sticky-box";

import Menu from "../Menu/index";
import styles from "./Sidebar.module.scss";

import { menuItems } from "../../constants";
const Sidebar = props => {
  const { className, ...rest } = props;
  return (
    <StickyBox offsetTop={56} offsetBottom={0}>
      <div className={classNames(styles.sidebar, className, 'bg-dark text-light flex-shrink-0')} {...rest}>
        <Menu
          items={menuItems}
          vertical
          location={props.location}
          isDesktop={desktop()}
        />
      </div>
    </StickyBox >
  )
}

export default Sidebar;